/* flamel-cro-events.js v8 — 2026-09-16 — generated by build-bridge-v8.cjs.
 * Live v7 SHA256: 170c4cdf38c3c8580f0ef476d30368f96d1c6fc0f085819fbd2571a66857674f
 * Account navigation module SHA256: efcad79405fe50010861972dc80efc6b95ff86473a6bdc2e605f2447874ad55b
 * Full asset: preserves hero, kit, account, cart and PDP instrumentation.
 */
/* ============================================================
   Flamel Analytics — flamel-cro-events.js v7  (ARTEFACTO GENERADO, NO EDITAR)
   Cliente: Redi Food (redifood.co)
   Build:   2026-09-08 · node deliverables/2026-09-08/build-bridge.js
   Destino: tema borrador 188550676769 «Apartado privado usuario v2 + PDP Globo free»

   Es la concatenación, en este orden, de:
     [1] theme-hero-kit-events.js     v5 · hero + kit + pantalla 1 (sello del armador)
         sha1 711e894d44 · 18102 B
     [2] theme-cuenta-events.js       EXP-03 · área privada + intercept global de /cart/add.js
         sha1 2d819d57d9 · 16790 B
     [3] theme-pdp-events.js          EXP-04 · PDP de almuerzos
         sha1 256f3c7de6 · 11260 B

   Un solo asset, un solo publish: publicar el tema publica los cuatro trabajos
   (pantalla 1, EXP-03, intercept global de add_to_cart, EXP-04). Para cambiar
   algo, edita la fuente correspondiente y vuelve a construir; parchear este
   fichero a mano se pierde en el siguiente build.
   ============================================================ */

/* ============================================================
   Flamel Analytics — Instrumentación CRO (Hero + Kit entry)
   Cliente: Redi Food (redifood.co)
   Generated: 2026-06-19 por flamel-analytics-dept (experimentos CRO)
   Updated:   2026-06-24 — drill-down del mini-funnel del kit (Fase A):
              + kit_size ('5'|'7'|'14'|'premium') consistente en start/complete/abandon
              + listener flamel:kit:step → kit_step / kit_step_name en el abandono
   Updated:   2026-09-08 (v7) — SOLO cambia el valor de KIT_UI_VERSION (ver comentario
              junto a la constante). Copia de la fuente del 2026-08-26 para que el build
              de v7 (build-bridge.js) lea de esta carpeta y no de la anterior.
   Updated:   2026-08-26 (v5) — instrumentación de la PRIMERA PANTALLA:
              + kit_ui_version en TODOS los eventos (sella qué versión vio el usuario)
              + kit_card_click por delegación de clic sobre las cards de kit
              Motivo: la pantalla 1 no emitía nada. Solo se sabía "entró" (kit_builder_view)
              y "pasó al paso 2" (kit_builder_start), así que un cambio en las cards —como
              el de las imágenes del 18-ago— solo se podía medir por diferencia de fechas.

   ⚠️ OJO CON kit_ui_version: NO rellena hacia atrás. Sirve para comparar el PRÓXIMO
      cambio limpiamente, no para medir el de las imágenes. Sube la constante de abajo
      cada vez que se publique un cambio visible del armador.
   Spec ref: clients/redifood/deliverables/2026-06-19/hero-kit-instrumentation-spec.md
             clients/redifood/deliverables/2026-06-24/README-kit-drilldown.md

   AÑADE los eventos nuevos requeridos por los 2 experimentos CRO, SIN tocar la
   instrumentación v1 (theme-datalayer-events.js sigue igual). Cargar DESPUÉS de
   flamel-datalayer-events.js.

   INSTALACIÓN:
   1. Subir a `assets/flamel-cro-events.js`
   2. En layout/theme.liquid, tras el script de flamel-datalayer-events.js:
        {{ 'flamel-cro-events.js' | asset_url | script_tag }}
   3. Marcar en el theme:
        - El contenedor del HERO con  data-flamel-hero  (y opcional data-hero-variant="control|v2")
        - El CTA del hero que lleva al armado de kit con  data-flamel-cta="kits_hero"
        - El contenedor del kit builder con  data-flamel-kit-builder
      (Si la UI del kit emite CustomEvents, también se escucha flamel:kit:view.)

   EVENTOS QUE EMITE (dataLayer):
     - hero_section_view    { hero_id, hero_variant, hero_dwell_ms }   (1×/sesión, al flush)
     - cta_kits_hero        { hero_id, hero_variant }
     - kit_builder_view     { kit_entry }                              (1×/sesión)
     - kit_builder_start    { kit_type, kit_size }
     - kit_builder_add_item { items_count, kit_value, currency }
     - kit_builder_complete { items_count, kit_value, currency, kit_type, kit_size }
     - kit_builder_abandon  { items_count, kit_type, kit_size, kit_step, kit_step_name }
     - kit_card_click       { kit_id, kit_size, card_position, card_has_image, card_kind }
     (kit_size = '5'|'7'|'14'|'premium'; kit_step_name = Tamaño|Almuerzos|Resumen)
     (card_kind = 'card' para las tarjetas grandes, 'chip' para la navegación rápida)
     TODOS llevan además kit_ui_version.

   COMPAT: ES5+, sin dependencias. Reusa los mismos patrones que v1.
   ============================================================ */

(function () {
  "use strict";

  window.dataLayer = window.dataLayer || [];

  /* Sello de versión de la UI del armador.
     Vive en el ASSET, no en el bundle de React: así el acto de publicar el tema es lo
     que sella la versión, y no hace falta recompilar nada para marcar un cambio.
     SUBIR ESTE VALOR cada vez que se publique un cambio visible del armador. */
  /* 2026-09-08 (v7): el sello vuelve a "2026-08-18-imagenes". El v6 decía
     "2026-08-26-copy-restaurado" porque en el borrador 188271657249 se restauró el
     titular de la pantalla 1; el borrador que se publica ahora (188550676769) lleva el
     bundle del armador del tema VIVO byte a byte (sha 647ba08a6c), o sea, SIN ese copy.
     Un sello que describe una UI que nadie ve invalida la comparación. Si Web Design
     porta el copy restaurado a este borrador, súbelo aquí a la vez. */
  var KIT_UI_VERSION = "2026-08-18-imagenes";

  function dlPush(eventName, extras) {
    var payload = { event: eventName };
    if (extras) {
      Object.keys(extras).forEach(function (k) {
        payload[k] = extras[k];
      });
    }
    /* Va en todos los eventos, no solo en los de la pantalla 1: sin esto, comparar dos
       versiones obliga a partir por fecha, y la fecha de publicación de un tema de
       Shopify no la expone la API. */
    payload.kit_ui_version = KIT_UI_VERSION;
    window.dataLayer.push(payload);
  }

  /* Clarity mirror (no-op si Clarity no está instalado) */
  function clarityEvent(n) {
    if (typeof window.clarity === "function") {
      try {
        window.clarity("event", n);
      } catch (e) {}
    }
  }

  var SS = window.sessionStorage;
  function once(key) {
    try {
      if (SS.getItem(key)) return false;
      SS.setItem(key, "1");
      return true;
    } catch (e) {
      return true; // si sessionStorage falla, no bloqueamos el evento
    }
  }

  /* ========================================================
     EXP-02 — HERO SECTION
     ========================================================
     Estrategia para "tiempo de visualización": acumulamos el tiempo en que el
     hero está ≥50% visible (IntersectionObserver) y disparamos UN solo
     hero_section_view por sesión con hero_dwell_ms en el primer flush:
       - el hero sale de viewport tras haber sido visto, o
       - visibilitychange -> hidden, o
       - beforeunload (cierre/navegación), o
       - clic en el CTA del hero.
  */
  (function initHero() {
    // Selectores reales del hero de Redi (sections/hero-redi.liquid): la <section>
    // lleva [data-rf-hero] y el CTA es .rf-hero__cta. La variante vive en data-theme
    // (opt1|opt2|cream|forest). Fallback a los data-flamel-* por si se renombra.
    var hero = document.querySelector("[data-rf-hero], .rf-hero, [data-flamel-hero]");
    if (!hero || typeof IntersectionObserver !== "function") return;

    var heroId = hero.getAttribute("data-hero-id") || "home_hero";
    var heroVariant =
      hero.getAttribute("data-theme") ||
      hero.getAttribute("data-hero-variant") ||
      "control";

    var visibleSince = 0; // timestamp en que entró a ≥50%
    var dwellMs = 0; // acumulado
    var seen = false;
    var flushed = false;

    function accumulate() {
      if (visibleSince) {
        dwellMs += Date.now() - visibleSince;
        visibleSince = 0;
      }
    }

    function flush(reason) {
      if (flushed) return;
      if (!seen) return;
      accumulate();
      flushed = true;
      dlPush("hero_section_view", {
        hero_id: heroId,
        hero_variant: heroVariant,
        hero_dwell_ms: Math.round(dwellMs),
        flush_reason: reason || ""
      });
      clarityEvent("hero_section_view");
    }

    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            seen = true;
            if (!visibleSince) visibleSince = Date.now();
          } else {
            // salió de viewport tras haber sido visto -> contabiliza y flush
            accumulate();
            if (seen) flush("scrolled_out");
          }
        });
      },
      { threshold: [0, 0.5, 1] }
    );
    obs.observe(hero);

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) flush("visibility_hidden");
    });
    window.addEventListener("beforeunload", function () {
      flush("beforeunload");
    });

    /* CTA del hero -> cta_kits_hero + asegura el flush del view */
    function bindCta() {
      // CTA real del hero: <a class="rf-hero__cta" ... data-promo-id="hero_kit">
      var cta = document.querySelector(
        '.rf-hero__cta, [data-promo-id="hero_kit"], [data-flamel-cta="kits_hero"]'
      );
      if (!cta) return;
      cta.addEventListener("click", function () {
        flush("cta_click");
        dlPush("cta_kits_hero", { hero_id: heroId, hero_variant: heroVariant });
        clarityEvent("cta_kits_hero");
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bindCta);
    } else {
      bindCta();
    }
  })();

  /* ========================================================
     BANNER de home → kit (cta_kits_banner)
     ========================================================
     Sección rf-kitbanner: CTA .rf-kb__cta (data-promo-id="kit_banner",
     slot home_banner) que también lleva a /pages/arma-tu-kit. */
  (function initBannerCta() {
    function bind() {
      var cta = document.querySelector('.rf-kb__cta, [data-promo-id="kit_banner"]');
      if (!cta) return;
      cta.addEventListener("click", function () {
        dlPush("cta_kits_banner", { cta_location: "home_banner" });
        clarityEvent("cta_kits_banner");
      });
    }
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", bind);
    } else {
      bind();
    }
  })();

  /* ========================================================
     EXP-01 — KIT BUILDER: evento de ENTRADA (kit_builder_view)
     ========================================================
     Cierra el gap del funnel ("usuarios que entraron"). 1×/sesión.
     Tres vías (la primera que ocurra):
       A) CustomEvent del theme/app:  document.dispatchEvent(new CustomEvent('flamel:kit:view'))
       B) IntersectionObserver sobre [data-flamel-kit-builder]
       C) match de URL del builder (data-attribute kit_entry='url')
  */
  (function initKitView() {
    function fireView(entry) {
      if (!once("flamel_kit_view")) return;
      dlPush("kit_builder_view", { kit_entry: entry || "" });
      clarityEvent("kit_builder_view");
    }

    // A) hook explícito
    document.addEventListener("flamel:kit:view", function () {
      fireView("custom_event");
    });

    // B) observer sobre el contenedor
    function bindObserver() {
      // Contenedor real donde monta la app React del kit: <div id="rk-root">
      var el = document.querySelector("#rk-root, [data-flamel-kit-builder]");
      if (el && typeof IntersectionObserver === "function") {
        var o = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) {
              if (e.isIntersecting) {
                fireView("intersection");
                o.disconnect();
              }
            });
          },
          { threshold: 0.3 }
        );
        o.observe(el);
      } else if (el) {
        fireView("present_on_load");
      }
    }

    // C) match de URL — path confirmado del builder en producción
    var KIT_PATHS = ["/pages/arma-tu-kit"];
    function checkUrl() {
      var p = window.location.pathname.toLowerCase();
      for (var i = 0; i < KIT_PATHS.length; i++) {
        if (p.indexOf(KIT_PATHS[i]) !== -1) {
          fireView("url_match");
          return;
        }
      }
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () {
        bindObserver();
        checkUrl();
      });
    } else {
      bindObserver();
      checkUrl();
    }
  })();

  /* ========================================================
     EXP-01 — FUNNEL del kit: traduce los CustomEvents del configurador
     (rk-app.jsx → fireKit) a eventos GA4 kit_builder_*. Autocontenido: NO
     depende del bridge v1, así que no hay doble conteo. Los tags GTM
     kit_builder_start/add_item/complete/abandon ya existen en el container v1.
     ======================================================== */
  (function initKitFunnel() {
    function ccy() {
      return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "COP";
    }
    var itemsCount = 0;
    // Último paso del wizard visto (Tamaño/Almuerzos/Resumen). El kit emite
    // flamel:kit:step; lo retenemos para adjuntarlo al abandono (drill-down "en qué
    // paso se quedó"). kit_size = la CLAVE del kit ('5'|'7'|'14'|'premium'), no el nº
    // de almuerzos: la app la manda en detail.kit en start/complete/abandon.
    var lastStep = "";
    var lastStepName = "";
    function kitSize(d) {
      return d.kit ? String(d.kit) : "";
    }

    document.addEventListener("flamel:kit:step", function (e) {
      var d = e.detail || {};
      if (d.step !== undefined && d.step !== null) lastStep = String(d.step);
      if (d.step_name) lastStepName = String(d.step_name);
    });
    document.addEventListener("flamel:kit:start", function (e) {
      var d = e.detail || {};
      itemsCount = 0;
      dlPush("kit_builder_start", { kit_type: d.kit_type || "", kit_size: kitSize(d) });
      clarityEvent("kit_builder_start");
    });
    document.addEventListener("flamel:kit:add", function (e) {
      var d = e.detail || {};
      itemsCount += 1;
      dlPush("kit_builder_add_item", { items_count: itemsCount, kit_value: Number(d.total) || 0, currency: ccy() });
    });
    document.addEventListener("flamel:kit:complete", function (e) {
      var d = e.detail || {};
      dlPush("kit_builder_complete", {
        items_count: itemsCount,
        kit_value: Number(d.total) || 0,
        currency: ccy(),
        kit_type: d.kit ? String(d.kit) : "",
        kit_size: kitSize(d),
      });
      clarityEvent("kit_builder_complete");
    });
    document.addEventListener("flamel:kit:abandon", function (e) {
      var d = e.detail || {};
      dlPush("kit_builder_abandon", {
        items_count: itemsCount,
        kit_type: d.kit ? String(d.kit) : "",
        kit_size: kitSize(d),
        kit_step: lastStep,
        kit_step_name: lastStepName,
      });
      clarityEvent("kit_builder_abandon");
    });

    /* ---------- PRIMERA PANTALLA: qué card se clica ----------
       La app React no emite nada al elegir kit (changeKit() no llama a analítica), así
       que se escucha por DELEGACIÓN sobre #rk-root. Ventaja: no hace falta recompilar el
       bundle, que hoy solo existe compilado y cuyo runbook de recompilación revierte el
       rediseño. Desventaja: depende de los nombres de clase; si el bundle renombra
       .rk-size, esto deja de emitir EN SILENCIO. Por eso se verifica en Tiempo real tras
       publicar, y por eso se escucha también un CustomEvent propio: el día que la app se
       recompile y emita flamel:kit:card, esa vía toma el relevo sin tocar nada aquí.

       Las dos rutas comparten deduplicación: si algún día la app emite el CustomEvent
       mientras el listener delegado sigue puesto, el evento no se manda dos veces. */

    var lastCardKey = "";
    var lastCardAt = 0;

    function kitKeyAt(index) {
      /* Las cards y los chips se pintan mapeando window.RK_SIZES en orden, así que la
         posición en el DOM es el índice del catálogo. Es la única forma de recuperar la
         clave del kit: el botón no lleva ningún data-attribute. */
      var sizes = window.RK_SIZES;
      if (!sizes || !sizes[index]) return "";
      return String(sizes[index].key || "");
    }

    function pushCardClick(info) {
      var now = new Date().getTime();
      /* Un clic real no se repite en 300 ms; dos pushes tan seguidos son la misma
         acción llegando por las dos vías. */
      if (info.kit_id && info.kit_id === lastCardKey && now - lastCardAt < 300) return;
      lastCardKey = info.kit_id || "";
      lastCardAt = now;
      dlPush("kit_card_click", {
        kit_id: info.kit_id || "",
        kit_size: info.kit_id || "",
        card_position: typeof info.card_position === "number" ? info.card_position : -1,
        card_has_image: info.card_has_image ? 1 : 0,
        card_kind: info.card_kind || "card",
      });
      clarityEvent("kit_card_click");
    }

    document.addEventListener(
      "click",
      function (ev) {
        var root = document.getElementById("rk-root");
        if (!root || !ev.target) return;

        var node = ev.target.nodeType === 1 ? ev.target : ev.target.parentNode;
        var card = null;
        var kind = "card";
        /* Subida manual por el árbol: .closest() no existe en los navegadores viejos que
           todavía aparecen en el tráfico de la tienda. */
        while (node && node !== root && node !== document.body) {
          if (node.className && typeof node.className === "string") {
            if (/\brk-size\b/.test(node.className)) { card = node; kind = "card"; break; }
            if (/\brk-chip\b/.test(node.className)) { card = node; kind = "chip"; break; }
          }
          node = node.parentNode;
        }
        if (!card || !card.parentNode) return;

        var siblings = card.parentNode.children;
        var pos = -1;
        for (var i = 0; i < siblings.length; i++) {
          if (siblings[i] === card) { pos = i; break; }
        }

        pushCardClick({
          kit_id: kitKeyAt(pos),
          card_position: pos,
          card_has_image: !!card.querySelector(".rk-size__img"),
          card_kind: kind,
        });
      },
      true /* fase de captura: el onClick de React llama a setState y repinta, así que
              en fase de burbuja el nodo puede haber sido reemplazado ya. */
    );

    /* Vía preferente para el futuro: si el bundle se recompila y emite el CustomEvent,
       llega con la clave del kit de primera mano en vez de deducirla por posición. */
    document.addEventListener("flamel:kit:card", function (e) {
      var d = e.detail || {};
      pushCardClick({
        kit_id: d.kit ? String(d.kit) : "",
        card_position: typeof d.index === "number" ? d.index : -1,
        card_has_image: d.has_image,
        card_kind: d.kind || "card",
      });
    });
  })();
})();

/* ============================================================
   Flamel Analytics — Instrumentación del ÁREA PRIVADA + «pedir de nuevo»
   Cliente: Redi Food (redifood.co)
   Generated: 2026-08-26 por flamel-analytics-dept
   Updated:   2026-09-08 (v7) — el intercept de /cart/add.js (§3) reconoce la PDP de
              almuerzos ([data-rf-pdp]) → add_origen="pdp", y sus fallos van a
              pdp_add_error en vez de repetir_kit_error. Nada más cambia.
   Tarea:    ClickUp 86cb89bd5 ("Conectar a GTM el experimento del área
             privada y de «pedir de nuevo»", radar de Andrés 2026-08-21)
   Spec:     clients/redifood/deliverables/2026-08-26/event-spec-cuenta.json
   Contexto: clients/redifood/deliverables/2026-08-26/README-area-privada.md

   QUÉ ES ESTO
   -----------
   El área privada (`/pages/mi-cuenta`, asset `rf-cuenta.js` del tema vivo)
   YA emite CustomEvents con la convención de la casa:

       window.dispatchEvent(new CustomEvent("flamel:cuenta:" + nombre, {detail}))

   ...pero nadie los escuchaba, así que no llegaba nada a GA4. Este módulo es
   el puente: CustomEvent → dataLayer → GTM → GA4 (+ espejo en Clarity).

   NO se toca `rf-cuenta.js`. No hay que tocarlo, y además no se puede tocar a
   ciegas: su código fuente no existe en ningún repo de la agencia — solo vive
   compilado en el tema.

   TRES TRAMPAS QUE ESTE FICHERO RESUELVE (verificadas contra producción)
   ---------------------------------------------------------------------
   1. `rf-cuenta.js` despacha en **window**; el resto de `flamel-cro-events.js`
      escucha en **document**. Un CustomEvent despachado en `window` NO baja a
      `document`: si escuchas donde no toca, no llega nada y no hay error.
      → aquí se escucha en `window`.

   2. `flamel:cuenta:repetir` se emite ANTES de `pedirAlCarrito()`, y no hay
      ningún evento después (ni en el `.then()` ni en el fallo). Tal cual, se
      mediría la intención pero nunca el resultado.
      → el resultado sale del intercept de `/cart/add.js` (§3).

   3. `pedirAlCarrito` hace `fetch('/cart/add.js')` a pelo, así que Shopify no
      emite nada. Y `flamel-datalayer-events.js` (la instrumentación v1, que
      traía este intercept) NUNCA se instaló en el tema: por eso el tag
      `GA4 — add_to_cart` del contenedor vivo lleva meses sin dispararse en
      TODA la tienda, no solo aquí.
      → el intercept de §3 es global y revive ese tag de paso.

   INSTALACIÓN
   -----------
   Este módulo se ANEXA al final de `assets/flamel-cro-events.js`, que el tema
   ya carga en todas las páginas desde `layout/theme.liquid`. Así el despliegue
   es un único PUT de asset: cero ficheros Liquid tocados.

   ⚠️ ESE ASSET LO COMPARTEN DOS TRABAJOS. El mismo 2026-08-26, la
   instrumentación de la primera pantalla del armador (kit_card_click +
   kit_ui_version, ver README-instrumentacion-pantalla-1.md) publicó su propia
   v5 del bridge en el tema borrador 188271657249. Desplegar este módulo por
   separado habría revertido aquello en silencio — el clásico "el último que
   escribe gana". Por eso el artefacto `flamel-cro-events.v6.js` es
   theme-hero-kit-events.js (v5, hero + kit + pantalla 1) + este módulo, y va
   al MISMO tema borrador: un solo asset, un solo publish, nada que se pise.

   Se anexa en un IIFE propio y redeclara sus helpers a propósito: los de v5
   viven dentro de otro IIFE y no están en alcance.

   EVENTOS QUE EMITE (dataLayer)
   -----------------------------
     cuenta_gate_view      {}                                    1×/carga, solo sin sesión
     cuenta_login_click    {}                                    clic en «Entrar a mi cuenta»
     cuenta_view           { cuenta_pedidos }                    1×/sesión
     cuenta_panel_view     { cuenta_panel, panel_entry }         panel_entry: load|nav
     repetir_kit_start     { repetir_origen, items_count }       repetir_origen: pedido|guardado
     repetir_kit_add       { items_count, kit_value, currency, repetir_origen }
     repetir_kit_error     { error_motivo, repetir_origen }
     cuenta_guardar_kit    {}
     cuenta_copiar_referido{}
     cuenta_pronto_click   { cuenta_seccion }
     add_to_cart           { ecommerce:{currency,value,items[]}, add_origen }   ← global, toda la tienda
                           add_origen ∈ pdp | cuenta | pedido | guardado | armador   (v7 añade pdp)
   ============================================================ */

(function () {
  "use strict";

  window.dataLayer = window.dataLayer || [];

  /* Mismo contrato que `theme-datalayer-events.js` (v1): el reset de
     `ecommerce: null` antes de cada push evita que GTM arrastre el objeto
     `ecommerce` de un evento al siguiente. */
  function dlPush(eventName, extras, ecommerce) {
    var payload = { event: eventName };
    if (ecommerce) {
      window.dataLayer.push({ ecommerce: null });
      payload.ecommerce = ecommerce;
    }
    if (extras) {
      Object.keys(extras).forEach(function (k) { payload[k] = extras[k]; });
    }
    window.dataLayer.push(payload);
  }

  function clarityEvent(n) {
    if (typeof window.clarity === "function") {
      try { window.clarity("event", n); } catch (e) {}
    }
  }

  /* sessionStorage puede lanzar (Safari en privado, cookies bloqueadas). Si no
     se puede recordar, se prefiere disparar de más a perder el evento. */
  function once(key) {
    try {
      if (window.sessionStorage.getItem(key)) return false;
      window.sessionStorage.setItem(key, "1");
      return true;
    } catch (e) { return true; }
  }

  function ccy() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "COP";
  }

  function fromCents(cents) {
    return typeof cents === "number" ? cents / 100 : 0;
  }

  function alEstarListo(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  /* El asset se carga bloqueante en el <head> (`asset_url | script_tag`), así
     que en este punto el <body> todavía no existe. Todo lo que toque el DOM va
     dentro de `alEstarListo`. Lo que NO puede esperar es el parche de `fetch`
     (§3): tiene que instalarse antes de que corra cualquier script de página. */

  /* ==========================================================
     1. GATE — la pantalla que ve quien NO tiene sesión
     ----------------------------------------------------------
     Es lo único que sirve el servidor a un visitante sin sesión: el resto del
     área privada lo pinta `rf-cuenta.js` en cliente. Medirlo aparte es lo que
     permite ver el BUCLE DE LOGIN que se reportó en la demo del 19-ago
     (ClickUp 86cb89b9w): mucha gente en `cuenta_gate_view`, poca llegando a
     `cuenta_view`.
     ========================================================== */
  alEstarListo(function () {
    var gate = document.querySelector(".rf-mc--gate");
    if (!gate) return;

    dlPush("cuenta_gate_view", { cuenta_estado: "logged_out" });
    clarityEvent("cuenta_gate_view");

    gate.addEventListener("click", function (ev) {
      var a = ev.target && ev.target.closest
        ? ev.target.closest('a[href*="customer_authentication"]')
        : null;
      if (!a) return;
      dlPush("cuenta_login_click", { cuenta_estado: "logged_out" });
      clarityEvent("cuenta_login_click");
    });
  });

  /* ==========================================================
     2. ÁREA PRIVADA — los 7 CustomEvents de `rf-cuenta.js`
     ----------------------------------------------------------
     Los listeners se registran SIEMPRE (no dentro de `alEstarListo` ni tras
     comprobar `[data-rf-cuenta]`): `rf-cuenta.js` es `defer`, así que despacha
     después del DOMContentLoaded, pero registrar antes es gratis y elimina
     cualquier carrera. En una página que no sea la cuenta, sencillamente no
     llega ningún evento.
     ========================================================== */

  /* `repetir` se emite antes del fetch; §3 lo lee para saber de dónde salió el
     add. Se limpia solo con un timeout por si el fetch nunca llega a hacerse. */
  var origenPendiente = null;
  var origenTimer = null;
  function marcarOrigen(origen) {
    origenPendiente = origen;
    clearTimeout(origenTimer);
    origenTimer = setTimeout(function () { origenPendiente = null; }, 15000);
  }

  window.addEventListener("flamel:cuenta:ver", function (e) {
    var d = (e && e.detail) || {};
    if (!once("flamel_cuenta_view")) return;
    dlPush("cuenta_view", {
      cuenta_pedidos: Number(d.pedidos) || 0,
      cuenta_estado: "logged_in"
    });
    clarityEvent("cuenta_view");
  });

  /* `mostrar()` corre también en el render inicial (`mostrar(delHash(), false)`),
     así que la primera visita SIEMPRE emite un panel que no es navegación.
     `panel_entry` lo separa en vez de tirarlo: saber con qué panel entra la
     gente (por hash, desde un email) es información, no ruido. */
  var primerPanel = true;
  window.addEventListener("flamel:cuenta:panel", function (e) {
    var d = (e && e.detail) || {};
    dlPush("cuenta_panel_view", {
      cuenta_panel: String(d.panel || "inicio"),
      panel_entry: primerPanel ? "load" : "nav"
    });
    clarityEvent("cuenta_panel_" + String(d.panel || "inicio"));
    primerPanel = false;
  });

  window.addEventListener("flamel:cuenta:repetir", function (e) {
    var d = (e && e.detail) || {};
    marcarOrigen("pedido");
    dlPush("repetir_kit_start", {
      repetir_origen: "pedido",
      items_count: Number(d.lineas) || 0
    });
    clarityEvent("repetir_kit_start");
  });

  window.addEventListener("flamel:cuenta:repetir_guardado", function () {
    marcarOrigen("guardado");
    dlPush("repetir_kit_start", { repetir_origen: "guardado", items_count: 0 });
    clarityEvent("repetir_kit_start");
  });

  window.addEventListener("flamel:cuenta:guardar_kit", function () {
    dlPush("cuenta_guardar_kit", {});
    clarityEvent("cuenta_guardar_kit");
  });

  window.addEventListener("flamel:cuenta:copiar_ref", function () {
    dlPush("cuenta_copiar_referido", {});
    clarityEvent("cuenta_copiar_referido");
  });

  /* El nombre de la sección viaja en el propio evento, así que esto sigue
     funcionando cuando Redi añada o quite un «próximamente» sin avisarnos.
     Es la señal de roadmap: qué pide la gente que todavía no existe. */
  window.addEventListener("flamel:cuenta:pronto", function (e) {
    var d = (e && e.detail) || {};
    dlPush("cuenta_pronto_click", { cuenta_seccion: String(d.seccion || "(sin nombre)") });
    clarityEvent("cuenta_pronto_click");
  });

  /* v7: el módulo PDP (theme-pdp-events.js) expone window.__flamelPdpError para
     deduplicar con su propio listener de flamel:pdp:add_error. Si por lo que sea no
     está cargado, se emite directo: mejor un duplicado que un hueco. */
  function emitirErrorPdp(motivo) {
    if (typeof window.__flamelPdpError === "function") {
      window.__flamelPdpError(motivo, "intercept");
      return;
    }
    dlPush("pdp_add_error", { error_motivo: motivo, add_origen: "pdp" });
    clarityEvent("pdp_add_error");
  }

  /* ==========================================================
     3. /cart/add.js — el resultado del «pedir de nuevo», y el
        `add_to_cart` que le falta a toda la tienda
     ----------------------------------------------------------
     Parche aditivo: mismo request, misma respuesta, mismo Promise. Se lee una
     COPIA del body (`res.clone()`), nunca el original — consumirlo rompería a
     quien hizo la llamada.

     Reutiliza la lógica ya escrita y revisada de
     `deliverables/2026-05-20/shopify-implementation/theme-datalayer-events.js`
     §1, que nunca llegó a instalarse en el tema.
     ========================================================== */
  (function () {
    if (typeof window.fetch !== "function") return;
    if (window.__flamelCartHook) return;   // idempotente: si algún día se instala v1, no se duplica
    window.__flamelCartHook = true;

    var fetchOriginal = window.fetch;

    window.fetch = function (input, init) {
      var url = "";
      try {
        url = typeof input === "string" ? input : (input && input.url) || "";
      } catch (e) {}

      var esAdd = url.indexOf("/cart/add") !== -1;
      var promesa = fetchOriginal.apply(this, arguments);
      if (!esAdd) return promesa;

      /* 2026-09-08 (v7): la PDP de almuerzos (plantilla product.almuerzo, raíz
         [data-rf-pdp]) también hace fetch('/cart/add.js') a pelo. Su add se marca
         "pdp": es el numerador del KPI de EXP-04 (add_to_cart con add_origen=pdp /
         pdp_view). Va antes que "armador" porque ese era el fallback para TODO lo
         que no fuera cuenta, y habría absorbido la PDP en silencio. */
      var origen = origenPendiente
        || (document.querySelector("[data-rf-pdp]") ? "pdp"
          : document.querySelector("[data-rf-cuenta]") ? "cuenta"
          : "armador");
      origenPendiente = null;
      clearTimeout(origenTimer);

      return promesa.then(function (res) {
        try {
          if (!res || !res.ok) {
            var motivoHttp = "http_" + ((res && res.status) || "sin_respuesta");
            /* v7: el fallo de la PDP es pdp_add_error, no repetir_kit_error — no es un
               «pedir de nuevo» y contaminaría el embudo de la cuenta. El módulo PDP
               emite también su propio pdp_add_error desde flamel:pdp:add_error; se
               deduplican allí por (motivo, 500 ms). */
            if (origen === "pdp") {
              emitirErrorPdp(motivoHttp);
            } else {
              dlPush("repetir_kit_error", { repetir_origen: origen, error_motivo: motivoHttp });
              clarityEvent("repetir_kit_error");
            }
            return res;
          }

          res.clone().json().then(function (data) {
            try {
              if (!data || (!data.id && !data.items)) return;
              var items = data.items || [data];
              var valor = 0;

              var ga4Items = items.map(function (it) {
                var precio = fromCents(it.final_price || it.price || 0);
                var cantidad = it.quantity || 1;
                valor += precio * cantidad;
                return {
                  item_id: String(it.product_id || it.id || ""),
                  item_name: it.product_title || it.title || "",
                  item_variant: it.variant_title || "",
                  item_brand: it.vendor || "",
                  item_category: it.product_type || "",
                  price: precio,
                  quantity: cantidad
                };
              });

              /* (a) El add_to_cart estándar que le falta a toda la tienda. */
              var extrasAdd = { add_origen: origen };
              if (origen === "pdp") {
                /* v7: el brazo del experimento viaja también en el numerador del KPI,
                   para poder partir add_to_cart por versión de la PDP el día que
                   haya una v3 conviviendo con la v2. */
                var rootPdp = document.querySelector("[data-rf-pdp]");
                extrasAdd.pdp_ui_version = (rootPdp && rootPdp.getAttribute("data-pdp-ui-version")) || "";
              }
              dlPush(
                "add_to_cart",
                extrasAdd,
                { currency: ccy(), value: valor, items: ga4Items }
              );
              clarityEvent("add_to_cart");

              /* (b) El paso del funnel de repetición: solo cuando el add salió
                     del área privada. Va aparte de add_to_cart a propósito —
                     así el embudo se cuenta sin depender de segmentar por un
                     parámetro. */
              if (origen === "cuenta" || origen === "pedido" || origen === "guardado") {
                dlPush("repetir_kit_add", {
                  repetir_origen: origen,
                  items_count: ga4Items.length,
                  kit_value: valor,
                  currency: ccy()
                });
                clarityEvent("repetir_kit_add");
              }
            } catch (e) {}
          })["catch"](function () { /* body no-JSON: no es un add que sepamos leer */ });
        } catch (e) {}
        return res;
      }, function (err) {
        try {
          if (origen === "pdp") {
            emitirErrorPdp("network");
          } else {
            dlPush("repetir_kit_error", { repetir_origen: origen, error_motivo: "network" });
            clarityEvent("repetir_kit_error");
          }
        } catch (e) {}
        throw err;
      });
    };
  })();
})();

/* ============================================================
   Flamel Analytics — Instrumentación de la PDP DE ALMUERZOS (EXP-04)
   Cliente: Redi Food (redifood.co)
   Generated: 2026-09-08 por flamel-analytics-dept
   Tarea:    ClickUp 86cbb7af2 («Definir y preparar el siguiente experimento CRO»)
   Handoff:  Web design Department/key-accounts/redi-food/HANDOFF-analytics-exp04-2026-09-08.md
   Brief:    Web design Department/key-accounts/redi-food/pdp-2026/EXP-04-brief.md §5
   Spec:     clients/redifood/deliverables/2026-09-08/event-spec-pdp.json

   QUÉ ES ESTO
   -----------
   La plantilla `product.almuerzo` (35 almuerzos, sin GemPages ni Globo) emite
   CustomEvents con la convención de la casa desde `assets/pdp-redi.js`:

       document.dispatchEvent(new CustomEvent("flamel:pdp:" + nombre, { detail }))

   ...y nadie los escuchaba. Este módulo es el puente: CustomEvent → dataLayer →
   GTM → GA4 (+ espejo en Clarity). NO se toca `pdp-redi.js` (es de Web Design).

   TRAMPAS
   -------
   1. Los eventos van en **document** y NO burbujean (bubbles:false). El módulo
      de la cuenta escucha en `window` porque `rf-cuenta.js` despacha ahí; si se
      copia ese patrón aquí no llega nada, y no hay error. → aquí, `document`.
   2. El add real lo hace `fetch('/cart/add.js')`; el `add_to_cart` estándar y su
      `add_origen="pdp"` los pone el intercept global del módulo de la cuenta
      (theme-cuenta-events.js §3), que en v7 reconoce `[data-rf-pdp]`. Este
      módulo NO emite add_to_cart: un segundo push doblaría la conversión.
   3. `flamel:pdp:add_error` y el intercept ven el mismo fallo. Se deduplican
      aquí por (motivo, 500 ms) vía `window.__flamelPdpError`.
   4. `pdp_ui_version` viaja en el `detail` de todos los eventos (lo pone el
      emisor desde `window.RF_PDP.uiVersion`). Fallback: el atributo
      `data-pdp-ui-version` de la raíz. Es el brazo del experimento: sin él
      no hay pre/post.
   5. Este asset se carga bloqueante en el <head>: nada del DOM existe aún.
      Los listeners de CustomEvent se registran ya (es gratis); el banner
      espera a DOMContentLoaded.

   EVENTOS QUE EMITE (dataLayer) — todos llevan pdp_product y pdp_ui_version
   -----------------------------
     pdp_view          { pdp_price, pdp_variant }               1×/carga (lo garantiza el emisor)
     pdp_side_open     { pdp_slot, open_method }                open_method: tap|auto|cta_blocked
     pdp_filter        { filter_id, pdp_slot }
     pdp_side_tap      { pdp_slot, side_id, side_name, filter_id, card_position, deselect }
     pdp_side_pick     { pdp_slot, side_id, side_name, filter_id, is_change }   ← confirma
     pdp_cta_blocked   { missing_slots }
     pdp_add_error     { error_motivo, add_origen:"pdp" }
     pdp_video_play    {}
     pdp_restock_submit {}                                       agotado: envío del «avísame» (fakedoor, intención)
     pdp_restock_ok     {}                                       agotado: captura confirmada (vuelta con customer_posted=true)
     (pdp_view lleva además pdp_available 1|0)
     view_promotion / select_promotion  { promotion_id:"pdp_kit_banner", … }   banner «Sale mejor en kit»
   (add_to_cart con add_origen="pdp" sale del intercept, no de aquí.)
   ============================================================ */

(function () {
  "use strict";

  window.dataLayer = window.dataLayer || [];

  function dlPush(eventName, extras) {
    var payload = { event: eventName };
    if (extras) {
      Object.keys(extras).forEach(function (k) { payload[k] = extras[k]; });
    }
    window.dataLayer.push(payload);
  }

  function clarityEvent(n) {
    if (typeof window.clarity === "function") {
      try { window.clarity("event", n); } catch (e) {}
    }
  }

  function alEstarListo(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn);
    } else {
      fn();
    }
  }

  /* Versión y producto: primero lo que trae el evento, después el DOM. El
     emisor los pone siempre; el fallback existe para que un evento «raro» no
     salga sin brazo. */
  function uiVersion(d) {
    if (d && d.pdp_ui_version) return String(d.pdp_ui_version);
    var root = document.querySelector("[data-rf-pdp]");
    return (root && root.getAttribute("data-pdp-ui-version")) || "";
  }
  function producto(d) {
    if (d && d.pdp_product) return String(d.pdp_product);
    try {
      var m = window.location.pathname.match(/\/products\/([^/?#]+)/);
      return m ? m[1] : "";
    } catch (e) { return ""; }
  }

  /* Base común de todos los eventos PDP. `n` = campos extra ya tipados. */
  function base(d, n) {
    var out = { pdp_product: producto(d), pdp_ui_version: uiVersion(d) };
    if (n) Object.keys(n).forEach(function (k) { out[k] = n[k]; });
    return out;
  }
  function str(v) { return v === undefined || v === null ? "" : String(v); }
  function num(v, fallback) { var x = Number(v); return isNaN(x) ? fallback : x; }
  function slot(d) { return str(d.pdp_slot); }

  function on(nombre, fn) {
    /* SIEMPRE en document (trampa 1). Registrar antes del DOM es gratis y
       elimina la carrera con `pdp-redi.js`, que emite pdp:view al arrancar. */
    document.addEventListener("flamel:pdp:" + nombre, function (e) {
      var d = (e && e.detail) || {};
      try { fn(d); } catch (err) {}
    });
  }

  /* ==========================================================
     1. Embudo de la PDP
     ========================================================== */
  on("view", function (d) {
    dlPush("pdp_view", base(d, {
      pdp_price: num(d.pdp_price, 0),
      pdp_variant: str(d.pdp_variant),
      pdp_available: d.pdp_available === undefined ? 1 : num(d.pdp_available, 1)
    }));
    clarityEvent("pdp_view");
  });

  on("open", function (d) {
    dlPush("pdp_side_open", base(d, {
      pdp_slot: slot(d),
      open_method: str(d.open_method) || "tap"
    }));
    clarityEvent("pdp_side_open");
  });

  on("filter", function (d) {
    dlPush("pdp_filter", base(d, {
      filter_id: str(d.filter_id),
      pdp_slot: slot(d)
    }));
    clarityEvent("pdp_filter");
  });

  on("tap", function (d) {
    dlPush("pdp_side_tap", base(d, {
      pdp_slot: slot(d),
      side_id: str(d.side_id),
      side_name: str(d.side_name),
      filter_id: str(d.filter_id),
      card_position: num(d.card_position, -1),
      deselect: d.deselect ? 1 : 0
    }));
    clarityEvent("pdp_side_tap");
  });

  on("pick", function (d) {
    dlPush("pdp_side_pick", base(d, {
      pdp_slot: slot(d),
      side_id: str(d.side_id),
      side_name: str(d.side_name),
      filter_id: str(d.filter_id),
      is_change: d.is_change ? 1 : 0
    }));
    clarityEvent("pdp_side_pick");
  });

  on("blocked", function (d) {
    dlPush("pdp_cta_blocked", base(d, {
      missing_slots: str(d.missing_slots)
    }));
    clarityEvent("pdp_cta_blocked");
  });

  on("video_play", function (d) {
    dlPush("pdp_video_play", base(d));
    clarityEvent("pdp_video_play");
  });

  /* QA 2026-09-08: fakedoor de reposición cuando el almuerzo está agotado. El correo lo
     guarda el form 'customer' de Shopify (etiqueta restock-<handle>); aquí se mide la
     intención. pdp_view lleva pdp_available=0 en esas páginas, que es el denominador. */
  on("restock_submit", function (d) {
    dlPush("pdp_restock_submit", base(d));
    clarityEvent("pdp_restock_submit");
  });
  /* Captura confirmada: la página vuelve con ?customer_posted=true tras el hCaptcha de Shopify.
     Esta es la cifra que vale; restock_submit es solo la intención. */
  on("restock_ok", function (d) {
    dlPush("pdp_restock_ok", base(d, { restock_confirmed_by: str(d.restock_confirmed_by) || "param" }));
    clarityEvent("pdp_restock_ok");
  });

  /* `flamel:pdp:add` NO se traduce: el add_to_cart estándar (con ecommerce.items
     y add_origen="pdp") sale del intercept global de /cart/add.js. Se deja el
     listener vacío a propósito para que quede escrito que es deliberado. */
  on("add", function () {});

  /* ==========================================================
     2. Errores del add — dos fuentes, un evento
     ----------------------------------------------------------
     El emisor dispara flamel:pdp:add_error (status http o "network") y el
     intercept ve el mismo fallo. Gana el primero que llegue; el segundo, si
     trae el mismo motivo en <500 ms, se descarta. */
  var ultimoErrorMotivo = "";
  var ultimoErrorAt = 0;
  function emitirError(motivo, fuente) {
    var ahora = new Date().getTime();
    if (motivo === ultimoErrorMotivo && ahora - ultimoErrorAt < 500) return;
    ultimoErrorMotivo = motivo;
    ultimoErrorAt = ahora;
    dlPush("pdp_add_error", base(null, {
      error_motivo: motivo,
      add_origen: "pdp",
      error_fuente: fuente || "emisor"
    }));
    clarityEvent("pdp_add_error");
  }
  window.__flamelPdpError = emitirError;   // lo usa theme-cuenta-events.js §3

  on("add_error", function (d) {
    var s = d.status;
    var motivo = s === "network" ? "network" : "http_" + (s === undefined || s === null || s === "" ? "sin_respuesta" : String(s));
    emitirError(motivo, "emisor");
  });

  /* ==========================================================
     3. Banner «Sale mejor en kit» (rf-pdp-upsell) → view/select_promotion
     ----------------------------------------------------------
     Los tags GA4 — view_promotion / select_promotion existen en el contenedor
     desde v1, pero su emisor (theme-datalayer-events.js, v1) nunca se instaló:
     ningún banner de la tienda los dispara hoy. Se instrumenta aquí SOLO dentro
     de la PDP ([data-rf-pdp]) para no cambiar el comportamiento del resto del
     sitio desde un módulo de experimento. Parámetros = los del contrato v1.
     ========================================================== */
  alEstarListo(function () {
    var root = document.querySelector("[data-rf-pdp]");
    if (!root) return;

    function promoParams(el) {
      return {
        promotion_id: el.getAttribute("data-promo-id") || "",
        promotion_name: el.getAttribute("data-promo-name") || "",
        creative_name: el.getAttribute("data-promo-creative") || "",
        creative_slot: el.getAttribute("data-promo-slot") || "",
        pdp_product: producto(null),
        pdp_ui_version: uiVersion(null)
      };
    }

    var promos = document.querySelectorAll("[data-promo-id]");
    for (var i = 0; i < promos.length; i++) {
      (function (el) {
        var visto = false;
        if (typeof IntersectionObserver === "function") {
          var o = new IntersectionObserver(function (entries) {
            entries.forEach(function (en) {
              if (visto || !en.isIntersecting || en.intersectionRatio < 0.5) return;
              visto = true;
              o.disconnect();
              dlPush("view_promotion", promoParams(el));
            });
          }, { threshold: [0.5] });
          o.observe(el);
        }
        el.addEventListener("click", function () {
          dlPush("select_promotion", promoParams(el));
          clarityEvent("select_promotion");
        });
      })(promos[i]);
    }
  });
})();

/* ============================================================
   Redi Food — clics en los accesos del área privada (2026-09-16)
   Complementa cuenta_panel_view; no deriva clics de mostrar()/hashchange.
   Cuenta cada activación del menú lateral o los accesos de Inicio, incluso
   la pestaña activa y los botones Pronto. Solo envía valores de una allowlist.
   Se concatena al bridge publicado mediante build-bridge-v8.cjs.
   ============================================================ */
(function () {
  "use strict";

  if (window.__flamelCuentaNavBound) return;
  window.__flamelCuentaNavBound = true;

  var panels = ["inicio", "pedidos", "racha", "kits", "invita", "suscripcion", "datos"];
  var prontoPanels = {
    "Racha y ahorro": "racha",
    "Mis kits guardados": "kits",
    "Kits guardados": "kits",
    "Invita y gana": "invita",
    "Suscripción": "suscripcion"
  };

  // Captura funciona antes del handler de navegación que oculta el panel.
  // La delegación permite cargar este asset en <head>, antes de crear la cuenta.
  document.addEventListener("click", function (ev) {
    var target = ev.target;
    if (target && !target.closest) target = target.parentElement;
    var action = target && target.closest
      ? target.closest("[data-rf-nav], [data-rf-pronto]")
      : null;
    if (!action || !action.closest("[data-rf-cuenta]")) return;
    if (action.disabled || action.getAttribute("aria-disabled") === "true") return;

    var origin = action.closest(".rf-mc__side") ? "menu"
      : action.closest('[data-rf-panel="inicio"]') ? "inicio" : null;
    if (!origin) return; // Enlaces auxiliares de otros paneles no son accesos.

    var isPronto = action.hasAttribute("data-rf-pronto");
    var panel = isPronto ? prontoPanels[action.getAttribute("data-rf-pronto")]
      : action.getAttribute("data-rf-nav");
    if (panels.indexOf(panel) === -1) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cuenta_nav_click",
      cuenta_panel: panel,
      cuenta_disponibilidad: isPronto ? "pronto" : "disponible",
      cuenta_origen: origin
    });
  }, true);
})();
